<template>
  <div class="prodcontent">
    <div class="prodbody">
      <div class="bodybottom  wow slideInLeft" >
        <div class="divbox"  v-for="(item,index) of listAerdata" v-show="index>0">
          <div >
            <img :src="getimgsrc(item.img)"/>
          </div>
          <div class="textbox">
            <h3 v-html="$i18n.locale=='zh_HK'?item.name:item.nameEn">{{$i18n.locale=='zh_HK'? item.name:item.nameEn}}
            </h3>
            <span v-html="$i18n.locale=='zh_HK'?item.describe:item.describeEn">
              {{$i18n.locale=='zh_HK'?item.describe:item.describeEn}}
            </span>
<!--            <p>{{$t('header.Learnmore')}}</p>-->
          </div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
  import { WOW } from 'wowjs';

  export default {
    name: "aerospacecomp",
    props: ['listAerdata', ],
    mounted(){
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();
    },
    methods:{
      getimgsrc(imgvalue){
        if (imgvalue == null || imgvalue == '') {
          return '-'
        }
        var imgs = imgvalue.replace(/,/g, "")
        return process.env.BASE_IMG + imgs
      },
    },
  }
</script>

<style lang="less" scoped>
  @media only screen and (min-width: 800px) {
    .prodcontent {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 40px;
      .prodbody {
        width: 90%;
        /*max-width: 1850px;*/
        /*display: flex;*/
        /*flex-direction: column;*/
        align-items: center;

        .bodybottom {

          align-items: center;
          /*display: flex;*/
          /*align-items: flex-start;*/
          width: 100%;
          justify-content: space-around;

          .divbox {
            /*margin-top: 4%;*/
            margin: 4% 10px 0 1.2%;
            float: left;
            border: 1px solid #72767b;
            padding-top: 10px ;
            width: 22.5%;
            color: #393939;
            align-items: center;
            div:nth-child(1){
              margin-left: 3%;
              width: 93.5%;
              height: 50%;
              img{
                width: 100%;
              }
            }
            .textbox {
              height: 21vw;
              padding: 10px 15px;
              text-align: left;
              position: relative;
              overflow: hidden;
              h3{
                height: 3vh;
                overflow:auto;
              }
              h3:hover{
                color: black;
              }
              /*隐藏滚动条并可以滚动内容*/
              h3::-webkit-scrollbar {
                display: none;
              }
              span {
                height: 17vw;
                overflow:auto;
                display: inline-block;
                margin-top: 0.5em;
                font-size: 1.1em;
                line-height: 1.1em;
                /*transition: all 0.2s; //设置动画执行的时间为0.6s*/
                /*cursor: pointer;*/
              }
              /*隐藏滚动条并可以滚动内容*/
              span::-webkit-scrollbar {
                display: none;
              }
              span:hover{
                padding: 1%;
                /*background-color: #f0f0f0;*/
                color: black;
                border-radius: 2%;
              }
              p{
                padding-top: 5%;
                height: 2vh;
                width: 90%;
                /*position: absolute;*/
                font-weight: bold;
                text-align: center;
                bottom: 50px;
                font-size: 0.9em;
                transition: all 0.2s; //设置动画执行的时间为0.6s
                cursor: pointer;
              }
              p:hover{
                transform: scale(1.02);
                color: black;
              }
            }
          }
        }
      }
    }
  }
  // 小于800px
  @media only screen and (max-width: 800px) {
    .prodcontent {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 40px;
      .prodbody {
        width: 90%;
        /*max-width: 1850px;*/
        /*display: flex;*/
        /*flex-direction: column;*/
        /*align-items: center;*/

        .bodybottom {
          margin-top: 4%;
          /*display: flex;*/

          align-items: center;
          width: 100%;
          justify-content: space-around;

          .divbox {
            /*left: 100px;*/
            /*top: 10px;*/
            width: 43%;
            float: left;

            /*display:flex;*/
            align-items: center;
            margin: 2% 3%;
            border: 1px solid #72767b;
            padding-top: 2vw ;
            /*width: 45%;*/
            color: #393939;
            div:nth-child(1){
              margin-left: 4.5%;
              width: 90%;
              height: 50%;
              img{
                width: 100%;
              }
            }
            .textbox {
              height: 45vw;
              /*height: 43vh;*/
              padding: 1% 5%;
              text-align: left;
              position: relative;
              overflow: hidden;
              h3{
                height: 2vh;
                font-size: 2em;
                overflow:auto;
              }
              span {
                height: 38vw;
                overflow:auto;
                display: inline-block;
                margin-top: 3%;
                font-size: 1.6em;
                padding-bottom: 20%;
              }
              p{
                height: 2vh;
                font-weight: bold;
                width: 100%;
                /*position: absolute;*/
                text-align: center;
                bottom: 1vw;
                font-size: 1em;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Products/procomponents/aerospacecomp.vue